/**
 * Created by jonas on 2021-03-02.
 */
import {DasUBoot} from "../DasUBoot";
import {DasUBootRoundType} from "../server/DasUBootData";
import {gsap} from "gsap";
import {DasUBootGameMode} from "../server/DasUBootGameMode";
import {SymbolUtils} from "../utils/SymbolUtils";
import {DasUBootSymbol, DasUBootSymbolStates} from "../reels/DasUBootSymbol";

export class DasUBootRestore {


    public static restore(should:boolean):Promise<any> {
        return new Promise<any>((resolve, reject) => {
            if (!should) {
                resolve(undefined);
            }

            DasUBoot.reelView.reelFrame.xBombMultiplierDisplay.setMultiplier(DasUBoot.model.data.stickyFSMultiplier, true);

            if (DasUBoot.model.data.xNudges) {
                if (DasUBoot.model.data.xNudges.multipliers[0] > 0) {
                    DasUBoot.reelView.reelFrame.reelLamps[2].setValue(DasUBoot.model.data.xNudges.multipliers[0], true, DasUBoot.model.data.xNudges.multipliers[0]);
                }
                if (DasUBoot.model.data.xNudges.multipliers[1] > 0) {
                    DasUBoot.reelView.reelFrame.reelLamps[3].setValue(DasUBoot.model.data.xNudges.multipliers[1], true, DasUBoot.model.data.xNudges.multipliers[1]);
                }
            }


            const tl:gsap.core.Timeline = gsap.timeline({onComplete:()=>resolve(undefined)});
            tl.add(gsap.to(this, {duration:0.001}));

            switch (DasUBoot.model.data.roundType) {
                case DasUBootRoundType.FREE_SPIN:
                    tl.add(() => {
                        DasUBoot.keypadPlugin.setWin(DasUBoot.model.initData.accumulatedRoundWin, true, DasUBoot.isWinBelowStake());
                        DasUBoot.keypadPlugin.setZeroBetSpinCounter(DasUBoot.model.data.freespinsLeft);
                    })


                    tl.add(DasUBoot.reelView.raisePeriscope(true, 0, false));

                    tl.add(() => {
                        DasUBoot.reelView.reels[2].model.init(DasUBoot.model.clientData.reels[2]);
                        for (let symbol of DasUBoot.reelView.getVisibleSymbolInReel(2)) {
                            (<DasUBootSymbol>symbol.positionable).getStateAnimation(DasUBootSymbolStates.NORMAL);
                        }
                    });


                    if (DasUBoot.model.data.periscope && DasUBoot.model.data.periscope.hit) {
                        tl.add(DasUBoot.reelView.reelFrame.reelLamps[2].setValue(DasUBoot.model.data.periscope!.nudge+1, true, DasUBoot.model.data.periscope!.nudge+1));
                    }


                    break;
                case DasUBootRoundType.SUPER_FREE_SPIN:
                    tl.add(()=>{DasUBootRestore.restoreSuperFreespin()});
                    break;

            }

            if (DasUBoot.model.data.nextMode == DasUBootGameMode.FREESPIN || DasUBoot.model.data.nextMode == DasUBootGameMode.SUPER_FREESPIN){
                DasUBoot.keypadPlugin.setWin(DasUBoot.model.initData.accumulatedRoundWin, true, DasUBoot.isWinBelowStake());
            }

            if (DasUBoot.model.data.nextMode == DasUBootGameMode.AVALANCHE) {
                //Delete all X symbols
                tl.add(() => {
                    const explodePositions = DasUBoot.model.visibleReelsMatrix.getAllCoordinateForValue("X");
                    SymbolUtils.removeExplodedSymbols(explodePositions);
                });
            }

        });


    }


    private static restoreSuperFreespin() {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            DasUBoot.keypadPlugin.setWin(DasUBoot.model.initData.accumulatedRoundWin, true, DasUBoot.isWinBelowStake());
            DasUBoot.keypadPlugin.setZeroBetSpinCounter(DasUBoot.model.data.freespinsLeft);
            DasUBoot.reelView.reelFrame.lowerTorpedoTube(true, 0);
        });

        const parts = DasUBoot.model.clientData.torpedoParts;
        for (let part of parts) {
            if (part) {
                tl.add(DasUBoot.reelView.reelFrame.torpedoView.activatePart(0.1, part.reel, part.size, part.size, 3));
            }
        }

        tl.seek(tl.totalDuration(), false);
        return tl;

    }

}